import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start my-6 max-w-[666px]" }
const _hoisted_2 = { class: "input-label mb-6 flex items-center justify-start gap-x-3" }

import { useField } from 'vee-validate';

import Dropzone from '../../ui/Dropzone.vue';
import { useOnDrop } from '../../../hooks/useOnDrop';
import TooltipButton from '../TooltipButton.vue';


export default {
  __name: 'UploadedFileField',
  props: {
    title: {
        type: String,
        default: 'Zaświadczenie lekarskie (opcjonalne)',
    },
    hasTooltip: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;

const { value, setValue } = useField('uploadedFile');



const { onDrop, onSelectFile } = useOnDrop(setValue);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
      _createVNode(TooltipButton, null, {
        default: _withCtx(() => []),
        tooltip: _withCtx(() => [
          _createTextVNode("Aby lekarz mógł ocenić i przepisać leki nasenne, uspokajające, przeciwbólowe, psychotropowe lub przeciwpadaczkowe, załącz aktualną dokumentację medyczną (np. ostatnia recepta, wyniki badań lub dokumentacja szpitalna)")
        ]),
        _: 1
      })
    ]),
    _createVNode(Dropzone, {
      onChange: _unref(onSelectFile),
      "selected-file": _unref(value),
      onDrop: _withModifiers(_unref(onDrop), ["prevent"])
    }, null, 8, ["onChange", "selected-file", "onDrop"])
  ]))
}
}

}